import { formatISO } from 'date-fns'
import type { BaseFilter, DateFilter, Filter } from '../models/filter.model'

export const DEFAULT_FILTER_STATUS = [1, 2, 3, 4, 5, 6, 7]

export const DEFAULT_BASE_QUERY: BaseFilter = {
  action: undefined,
  countryId: undefined,
  zipZoneId: undefined,
  carrierId: undefined,
  serviceGroupId: undefined,
  dimensions: {
    1: undefined,
    2: undefined,
    3: undefined,
  },
  status: DEFAULT_FILTER_STATUS,
  isAssignedToMe: false,
}

export const DEFAULT_DATE_QUERY: DateFilter = {
  fromViewDate: formatISO(new Date()),
  toViewDate: formatISO(new Date()),
  fromActionDate: formatISO(new Date()),
  toActionDate: formatISO(new Date()),
  isActionDate: false,
  isViewDate: true,
}

export const DEFAULT_FILTER_QUERY: Filter = {
  ...DEFAULT_BASE_QUERY,
  ...DEFAULT_DATE_QUERY,
}
